import React from 'react';
import type { CaseStudyArtifact } from '../../types/content';
const bar = 'rounded-full bg-[#DCDCD8]';
const inkBar = 'rounded-full bg-ink';
function AuditArtifact() {
  const scores = [82, 46, 68, 24, 55];
  return <div className="flex h-full flex-col justify-center gap-2.5 rounded-md border border-hairline bg-white p-4" data-id="element-103" data-mp="1nowthgn71nmp">
      {scores.map((score, index) => <div key={score} className="flex items-center gap-3" data-id="element-104" data-mp="2gcivikgrwk7g" data-mpi={index}>
          <span className={`${index === 3 ? inkBar : bar} h-1.5 w-10 shrink-0`} data-id="element-105" data-mp="2gd2em4i5ten2" />
          <span className="h-1.5 flex-1 rounded-full bg-[#F1F1EE]" data-id="element-106" data-mp="2kd2vdvsqe1xa">
            <span className={`block h-1.5 rounded-full ${index === 3 ? 'bg-accent' : 'bg-[#DCDCD8]'}`} style={{
          width: `${score}%`
        }} data-id="element-107" data-mp="26mzfdmkg34ga" />
          </span>
          <span className="w-6 text-right text-[8px] tabular-nums text-muted" data-id="element-108" data-mp="2zboi1q15fhu5">{score}</span>
        </div>)}
    </div>;
}
function FlowArtifact() {
  return <div className="flex h-full items-center justify-between gap-1.5 rounded-md border border-hairline bg-white p-4" data-id="element-109" data-mp="343g17fhz6la9">
      {[0, 1, 2, 3].map(step => <React.Fragment key={step} data-id="element-110" data-mp="17qthbymcm4w2">
          <div className={`flex-1 rounded-sm border p-2 ${step === 2 ? 'border-accent' : 'border-hairline'}`} data-id="element-111" data-mp="17rv1qtp983qg">
            <span className={`block h-1.5 w-3/4 ${step === 2 ? 'bg-accent' : 'bg-ink'} rounded-full`} data-id="element-112" data-mp="1gqgl2r2jvmsa" />
            <span className={`mt-2 block h-1 w-full ${bar}`} data-id="element-113" data-mp="1vejr20gleyh3" />
            <span className={`mt-1.5 block h-1 w-2/3 ${bar}`} data-id="element-114" data-mp="1qgi434g1qf0c" />
          </div>
          {step < 3 && <svg viewBox="0 0 18 12" className="h-3 w-4 shrink-0" aria-hidden="true" data-id="element-115" data-mp="24g11b27bk5xv">
              <path d="M1 6 H15 M11 2 L15 6 L11 10" fill="none" stroke="#DCDCD8" strokeWidth="1" data-id="element-116" data-mp="1zh6lm94nexhz" />
            </svg>}
        </React.Fragment>)}
    </div>;
}
function SitemapArtifact() {
  return <div className="flex h-full flex-col items-center justify-center gap-3 rounded-md border border-hairline bg-white p-4" data-id="element-117" data-mp="53f64szn1jem">
      <span className={`h-4 w-16 rounded-sm bg-ink`} data-id="element-118" data-mp="256g9rlwm19l7" />
      <svg viewBox="0 0 120 16" className="h-4 w-3/4" aria-hidden="true" data-id="element-119" data-mp="2a4hsu6u1d8wo">
        <path d="M60 0 V6 M12 16 V6 H108 V16" fill="none" stroke="#E6E6E2" strokeWidth="1" data-id="element-120" data-mp="2a4rkdyuqbo4h" />
      </svg>
      <div className="grid w-full grid-cols-4 gap-2" data-id="element-121" data-mp="2f5p0m5w6i83c">
        {[0, 1, 2, 3].map(node => <div key={node} className="rounded-sm border border-hairline p-1.5" data-id="element-122" data-mp="2j6im6sm5fat2">
            <span className={`block h-1.5 w-full ${node === 0 ? 'bg-accent rounded-full' : bar}`} data-id="element-123" data-mp="2o3hed5m957om" />
            <span className={`mt-1.5 block h-1 w-2/3 ${bar}`} data-id="element-124" data-mp="2t1srpqbra0bl" />
          </div>)}
      </div>
    </div>;
}
function InventoryArtifact() {
  return <div className="grid h-full grid-cols-3 gap-2 rounded-md border border-hairline bg-white p-4" data-id="element-125" data-mp="32sx3kh64x527">
      {Array.from({
      length: 9
    }, (_, index) => index).map(item => <div key={item} className="flex flex-col justify-between rounded-sm border border-hairline p-2" data-id="element-126" data-mp="36sxis4125kab">
          <span className={`block h-1.5 w-full ${item === 4 ? 'bg-accent rounded-full' : inkBar}`} data-id="element-127" data-mp="3briogiz2ww65" />
          <span className={`mt-2 block h-1 w-3/4 ${bar}`} data-id="element-128" data-mp="v7ew8mak6gih" />
        </div>)}
    </div>;
}
const artifactContent = {
  audit: <AuditArtifact data-id="element-129" data-mp="r51qvyzq4km8" />,
  flow: <FlowArtifact data-id="element-130" data-mp="r6mmzt1osbm7" />,
  sitemap: <SitemapArtifact data-id="element-131" data-mp="r7xrjv2yhned" />,
  inventory: <InventoryArtifact data-id="element-132" data-mp="m7a058atf4jm" />
};
export function ArtifactFigure({
  artifact
}: {
  artifact: CaseStudyArtifact;
}) {
  return <figure data-id="element-133" data-mp="1ivy3qzlsap9i">
      <div className="flex aspect-[4/3] items-center justify-center overflow-hidden rounded-card border border-hairline bg-surface p-6 transition-[border-color] duration-300 ease-out hover:border-ink" data-id="element-134" data-mp="1ivpstd981u0y">
        <div className="h-full w-full" data-id="element-135" data-mp="1a34m4viv7dsh">{artifactContent[artifact.kind]}</div>
      </div>
      <figcaption className="mt-4" data-id="element-136" data-mp="154ji0l0hs9yr">
        <span className="block text-small font-medium text-ink" data-id="element-137" data-mp="153i8ikz4jvj5">{artifact.title}</span>
        <span className="mt-1 block text-small leading-5 text-muted" data-id="element-138" data-mp="22mbb4nqofgol">{artifact.caption}</span>
      </figcaption>
    </figure>;
}